export default __webpack_public_path__ + "static/media/money.d26f55d4.png";